<template>
  <span @click="open">
    <slot name="trigger"></slot>
  </span>
</template>
<script>
export default {
  props: ["component", "props"],
  methods: {
    open() {
      this.$buefy.modal.open({
        component: this.component,
        props: this.props,
        parent: this,
        width: 10000,
        hasModalCard: true,
        events: {
          'reload': (value) => {
            this.$emit('reload', value);
          }
        }
      });
    }
  }
};
</script>
